import { render } from "./403.vue?vue&type=template&id=42275701"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"
script.render = render

export default script